import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  Grid, Paper, Table, TableHead, Tooltip, Typography,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'

import { withStyles } from '@material-ui/core/styles'

import {
  getSupervisorLoginReport,
  getSupervisorSingleLoginReport
} from '../../../redux/actions'

import LoginInfoList from '../modals/LoginInfoList'

// import moment from 'moment'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

/**
 * Returns supervisor login report
 */
const SupervisorLoginReport = (props) => {
  const {
    classes, page, rowsPerPage, supervisorLoginReport, supervisorFilter
  } = props

  const dispatch = useDispatch()
  // const View = useSelector(state => state.userSettings.general.defaultView)

  // const [page, setPage] = useState(0)
  // const [rowsPerPage, setRowsPerPage] = useState(25)
  const [supervisorName, setSupervisorName] = useState(null)
  const [actionType, setActionType] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [loginInfo, setLoginInfo] = useState([])

  // Get the report on component load
  useEffect(() => {
    (async () => {
      await dispatch(getSupervisorLoginReport(supervisorFilter))
        .catch((err) => {
          console.error(err)
        })
    }
    )()
  }, [dispatch, supervisorFilter])

  // Handle getting login info for a single user and setting it for display
  const handleSingleLoginInfo = async (supervisorID, supervisorName) => {
  // Get login info for specific user by id
    const loginInfoRes = await dispatch(getSupervisorSingleLoginReport(
      { startDate: supervisorFilter.startDate, endDate: supervisorFilter.endDate },
      supervisorID
    ))
      .catch((err) => { console.error(err); return false })
    // Pass in users login info with relevant data to the login modal
    if (!loginInfoRes) { return false }

    // Remove current login sessions based on endedAt timestamp being greater than the current one
    // if (loginInfoRes) {
    //   loginInfoRes.forEach((loginInfo, index) => {
    //     if (loginInfo.endedAt > moment().unix()) { loginInfoRes.splice(index, 1) }
    //   })
    // }

    const loginArray = Array.from(loginInfoRes)
    if (loginArray && loginArray.length) {
      setLoginInfo(loginArray)
      setSupervisorName(supervisorName)
      setModalOpen(true)
    }
    return false
  }

  const toggleModal = () => {
    setModalOpen(false)
    setLoginInfo([])
    setActionType(null)
    setSupervisorName(null)
  }

  const truncateText = (str, length = 30) => {
    return str.length > 30 ? str.substring(0, length) + '...' : str
  }

  return (
    <>
      <LoginInfoList
        classes={classes}
        loginInfo={loginInfo}
        supervisor={supervisorName}
        toggleModal={toggleModal}
        open={modalOpen}
        actionType={actionType}
      />

      <Grid container direction='column' justify='center' style={{ minWidth: '650px' }}>
        <Grid container direction='row'>
          <Grid container item direction='column' justify='flex-end' xs={12} style={{ overflowX: 'scroll' }} className={classes.tableContainer}>
            <Paper elevation={2} className={classes.tablePaper}>
              <Grid
                container
                direction='column'
                justify='center'
                className='px-3 w-100 py-3 mx-auto my-auto'
                spacing={2}
              >
                {
                  supervisorLoginReport && supervisorLoginReport !== null && supervisorLoginReport.length > 0
                    ? (
                      <>
                        {/* <Grid container justify='center' spacing={1}>
                          <TablePagination
                            component='div'
                            count={websitesReport.length}
                            page={page}
                            onChangePage={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            rowsPerPageOptions={[100, 50, 25]}
                            color='secondary'
                          />
                        </Grid> */}
                        <TableContainer>
                          <Table className={classes.table} size='small' aria-label='users-table'>
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  size='small'
                                  className={`${classes.tableHeadText} unselectable`}
                                >
                                  Supervisor
                                </TableCell>
                                <TableCell
                                  size='small'
                                  align='right'
                                  className={`${classes.tableHeadText} unselectable`}
                                >
                                  Total Logins
                                </TableCell>
                                <TableCell
                                  size='small'
                                  align='right'
                                  className={`${classes.tableHeadText} unselectable`}
                                >
                                  Login Duration
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {supervisorLoginReport.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((supervisor, index) => (
                                <StyledTableRow key={index}>
                                  {/* SUPERVISOR NAME */}
                                  <TableCell
                                    size='small'
                                    className={`${classes.tableText} unselectable`}
                                    component='th'
                                    scope='row'
                                  >
                                    {
                                      (supervisor.firstName + ' ' + supervisor.lastName).length > 30
                                        ? (
                                          <LightTooltip title={supervisor.firstName + ' ' + supervisor.lastName} placement='top-end' arrow>
                                            <Typography className={classes.tableText}>{truncateText(supervisor.firstName + ' ' + supervisor.lastName)}</Typography>
                                          </LightTooltip>

                                        ) : (
                                          <Typography className={classes.tableText}>{supervisor.firstName + ' ' + supervisor.lastName}</Typography>
                                        )
                                    }
                                  </TableCell>
                                  {/* TOTAL LOGIN COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      handleSingleLoginInfo(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName)
                                    }}
                                  >
                                    {supervisor.loginCount || 0}
                                  </TableCell>
                                  {/* LOGIN DURATION */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      handleSingleLoginInfo(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName)
                                    }}
                                  >
                                    {supervisor.loginDuration || 0}
                                  </TableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : (
                      <>
                        <Grid item container direction='row' justify='center' alignItems='center'>
                          {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                          <Paper
                            className='mx-auto'
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginTop: '10vh',
                              height: '20rem',
                              width: '35rem',
                              padding: '1.5rem',
                              backgroundColor: '#F5F5F5'
                            }}
                          >
                            <Grid item container direction='column' xs={12}>
                              <Grid item container direction='row' justify='center'>
                                <AnnouncementIcon
                                  style={{
                                    fontSize: '4rem',
                                    color: 'grey',
                                    marginBottom: '1rem'
                                  }}
                                />
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography
                                  style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                >
                                  No Logins Found
                                </Typography>
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography>There are currently no supervisor logins for your account during the selected time frame. Please allow your supervisors time to take actions then try again.</Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </>
                    )
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default withRouter(SupervisorLoginReport)
